<template>
    <div
      class="modal fade"
      id="kt_modal_view_users"
      tabindex="-1"
      aria-hidden="true"
      ref="viewProductMoveMentAllMonthModalRef"
    >
    <div class="modal-dialog modal-dialog-centered  mw-1000px mh-100">
        <div class="modal-content">
          <div class="modal-header justify-content-between" style="height: 50px;">
            <h3 class="modal-title">{{ product.productName }}</h3>
            <!--begin::Close-->
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>

            <!--end::Close-->
          </div>            
            <div class="modal-body" style="padding: 0rem 1rem">
                <div class="row d-flex" >
                    <div class="col-md-5">
                        <div class="card">
                            <div  style="min-height: 50px; padding: 0 0rem">
                                <!-- <div class="card-title"> -->
                                    <div class="row pt-2 d-flex ">
                                        <!-- <div class="col-md-4">
                                            <date-time-picker-with-option 
                                            style="max-width: 250px"  
                                            v-model="filter.dateRange"
                                            @change="getStockMoveMent">
                                            </date-time-picker-with-option> 
                                        </div> -->
                                        <!-- <div class="col-md-8">
                                           <span> แสดงตาม {{typeView}} </span>
                                        </div>
                                        <div class="col-md-2"> -->
                                        <div class="col-6">
                                            <el-button-group class="ml-4" style="max-width: 250px" v-model="year" >
                                                <el-button type="primary" :plain="year=='LY'?false:true"  @click="handleButtonGroup('LY')" value="LY">ปีที่แล้ว</el-button>
                                                <el-button type="primary" :plain="year=='TY'?false:true" @click="handleButtonGroup('TY')"  value="TY" >ปีนี้</el-button>                                                
                                            </el-button-group>
                                        </div>
                                        
                                        <div class="col-6 pt-4">
                                            แสดงตาม {{typeView}}                                            
                                      
                                          <el-switch
                                                v-model="checkType"            
                                                @change="handleTypeViewChange"
                                            ></el-switch>
                                        </div>  
                                        <!-- </div> -->
                                    </div>
                                <!-- </div> -->
                            </div>
                            <div class="card-body" style="padding: 0px;">
                                    <el-table
                                    :data="products"
                                    style="width: 100%;"
                                    highlight-current-row 
                                    show-summary
                                    :summary-method="summary"                                      
                                    sortable
                                    :height="windowHeight"
                                    :cell-style="{padding: '0', height: '20px'}"
                                    >
                                    <!-- @current-change="onRowSelectHandler" -->
                                        <el-table-column prop="month" label="เดือน" align="left" sortable >
                                            <template #default="scope">  
                                                <div   @click="onRowSelectHandler(scope.row)">
                                                    <span style="cursor: pointer;">
                                                       {{scope.row.month}}
                                                    </span>
                                                </div>
                                            </template> 
                                        </el-table-column>
                                        <el-table-column   :prop="checkType?'stockInWeight':'stockInQuantity'" label="In" align="right" width="120" >
                                            <template #default="scope">  
                                                <div   @click="showProductMoveMent(scope.row,'In')">
                                                    <span style="cursor: pointer;">
                                                        <button class="btn btn-link" v-if="checkType" >{{ numberWithCommas(scope.row.stockInWeight, 2) }}  </button>
                                                        <button class="btn btn-link" v-else >{{ numberWithCommas(scope.row.stockInQuantity, 0) }} </button>
                                                    </span>
                                                </div>
                                            </template>  
                                        </el-table-column>    
                                        <el-table-column  :prop="checkType?'stockOutWeight':'stockOutQuantity'" label="Out" align="right"  width="120">
                                            <template #default="scope">  
                                                <div  @click="showProductMoveMent(scope.row,'Out')">
                                                    <span style="cursor: pointer;">
                                                        <button class="btn btn-link" v-if="checkType" >{{ numberWithCommas(scope.row.stockOutWeight, 2) }}  </button>
                                                        <button class="btn btn-link" v-else >{{ numberWithCommas(scope.row.stockOutQuantity, 0) }} </button>
                                                    </span>
                                                </div>
                                            </template>  
                                        </el-table-column>    
                                    </el-table>
                                     
                            </div>
                        </div>
                        <loading v-model:active="isLoading"
                        :loader="dots" 
                        :is-full-page="false"/>          
                    </div>
                    <div class="col-md-7" >
                         <product-move-ment  ref="productMovementRef" :month="selectedData.month" :year="year" :stock="product.stockQuantity" :unitStock="product.productUnitName"></product-move-ment>   
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</template>

<style scoped>
.custom-cell {
  background-color: yellow; /* Set the desired background color */
}
</style>
<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO, formatDateTimeFromISO } from "@/utils";
import Loading from 'vue-loading-overlay';
import { validateRole, role } from "@/helpers/role"
import DateTimePickerWithOption from '../../components/forms/DateTimePickerWithOption.vue';
// import ProductMoveMentModal from "../reports/ProductMoveMonth.vue";
import { DateTime } from 'luxon'
import ProductMoveMent from './ProductMoveMent.vue';

export default {
    mounted: function (){
        this.productMoveMentAllMonthModal = new Modal(this.$refs.viewProductMoveMentAllMonthModalRef);
    },     
    components: {
        Loading,
        ProductMoveMent,
        //  DateTimePickerWithOption,
    },
    data(){
        return{
            windowHeight: window.innerHeight - 180,
            productMoveMentAllMonthModal: null,
            products: [], 
            product: [],     
            selectedData:[], 
            isLoading: false,   
            filter: {
                dateRange: [],
            },  
            type:"piece",
            checkType:false,
            typeView:"หน่วย",
            unit:"เส้น",   
            year:"TY"   
        }
    },  
    computed: {
     
      ModalHeight() {
        return this.windowHeight - 250
      },
      tbHeight() {
        return this.windowHeight - 120
      },
      isAdmin() {
          return validateRole(role.admin)
      },
      thisMonth(){
        var date = new Date()
        //console.log(" date.getMonth();", date);
        return date.getMonth()+1;
      }
    },
    methods:{
        show(product) {
            this.productMoveMentAllMonthModal.show();
            this.product = product;
            this.getStockMoveMent();
        },
        hide() {
            this.clearData();            
            this.selectedData=[];
            this.productMoveMentAllMonthModal.hide();
            
        }, 
        handleSelectionChange(val) {
            console.log("handleSelectionChange val" ,val);
        },  
        
        handleButtonGroup: async function (val) {
            this.year=val;
            if(this.$refs.productMovementRef){
                this.$refs.productMovementRef.clearData();
            }
            this.getStockMoveMent();

        },       
        getStockMoveMent: async function () {
            this.isLoading = true;
            try {
                const { data } = await ApiService.query("products/StockTransaction?SDate=" + DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd') + "&EDate=" + DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd') + "&ProductID=" + this.product.productID + "&PartnerCode=" + this.product.partnerCode + "&Year=" + this.year);
               
                 this.products = data && data.length>0?data.filter((p) => this.year == 'LY' || (this.year == 'TY' && (p.month < this.thisMonth || p.month == this.thisMonth) ) ):[];
            
            } catch (error) {
                console.log(error);
            }            

            this.isLoading = false;
        },
        summary({columns, data}) {
            const sums = [];
            columns.forEach((col, index) => {
                // if(index === 0) {
                // sums[index] = data.length + ' รายการ';
                // }

                
                if(col.property == "stockInQuantity" || col.property == "stockInWeight") {
                    let totalIn =  data.reduce(
                        (prev, curr) => {
                        return  prev + curr[col.property] 
                        },
                        0
                    )
                    sums[index] = col.property == "stockInQuantity"?this.numberWithCommas(totalIn, 0):this.numberWithCommas(totalIn, 2);
                }

                if(col.property == "stockOutQuantity" || col.property == "stockOutWeight") {
                    let totalOut =  data.reduce(
                        (prev, curr) => {
                        return  prev - curr[col.property]
                        },
                        0
                    )
                    sums[index] = col.property == "stockOutQuantity"?this.numberWithCommas(totalOut, 0):this.numberWithCommas(totalOut, 2);
                }

            })    
            return sums;
        },             
        formatDateFromISO,
        numberWithCommas,
        formatDateTimeFromISO,
        handleTypeViewChange(){
            // console.log(this.checkType)
            if(this.checkType){
                this.type = "weight";
                this.typeView = "น้ำหนัก";
                this.unit="mt."
            }else{
                this.type = "piece";
                this.typeView = "หน่วย";
                this.unit="เส้น";
                
            }
        },
        showProductMoveMent(data,stockInOut){
            data.partnerCode = this.product.partnerCode;
            data.productID = this.product.productID;
            data.stockInOut = stockInOut;
            data.selectType = "Item";
            this.selectedData=data;
            if(this.$refs.productMovementRef){
                this.$refs.productMovementRef.setData(this.selectedData);
            }
        },
        onRowSelectHandler(selection) {
            //console.log("onRowSelectHandler",selection)
            selection.partnerCode = this.product.partnerCode;
            selection.productID = this.product.productID;
            selection.selectType = "Row";
            selection.stockInOut="Row";
            this.selectedData=selection;
            if(this.$refs.productMovementRef){
                this.$refs.productMovementRef.setData(this.selectedData);
            }
        },
        clearData() {
            this.year = "TY";
            this.type = "piece";
            this.typeView = "หน่วย";
            this.unit="เส้น";
            this.checkType=false;
            if(this.$refs.productMovementRef){
                this.$refs.productMovementRef.clearData();
            }
            
        },        
    },
    created() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        this.filter.dateRange[0] = new Date(y, 0, 1)
        this.filter.dateRange[1] = new Date(y, 12, 0)
        this.year = "TY";
        this.type = "piece";
        this.typeView = "หน่วย";
        this.unit="เส้น";
    },    
           
}
</script>
